import omit from 'lodash-es/omit';

import { isEmpty } from '@app/util/util';
import { decodeURIParams, encodeURIParams } from '@app/mappers/encoding.mapper';
import { SelectedFareVM } from '@activities/activities-results/entities/activities-detail';
import { CalendarDay } from '@design-system/components/molecules/calendar/entities/calendar.types';
import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { bookingBaseRoute } from '@booking/constants/booking-routes.constants';
import { ActivityFareBookParamsVM } from '@activities/entities/activities-booking';
import { PaxType } from '@booking/entities/pax-type';
import { InputTravelExtra } from '@shared/base-search-bar/entities/autocomplete-travel-extra';
import { ActivitySearchCodeType } from '../../entities/activities-acutocomplete';

const _ = '_';
const FARE = '_fare_';
export const RESULT_PARAMS_DIVIDER = '_:ctid:_';

export function getActivitiesBookingParams(
  searchId: string, optionId: string, selectedFares: SelectedFareVM[], selectedDate: CalendarDay
): string[] {
  const fares = selectedFares?.filter(fare => fare.Quantity)
    .map(fare => `${fare.Type}${_}${fare.FareId}${_}${fare.Quantity}${_}${selectedDate.iso}`) ?? [];
  return [bookingBaseRoute, searchId, optionId, encodeURIParams(fares.join(FARE)), TravelBookingType.ACTIVITIES];
}

export function getActivitiesBookingFareParam(param: string, _omit: string[] | undefined = []): ActivityFareBookParamsVM[] {
  const fares = decodeURIParams(param)?.split(FARE) ?? [];
  return fares.filter(fare => !isEmpty(fare)).map(fare => {
    const params = fare?.split(_) ?? [];
    return params.reduce((acc, cur, i) => {
      const key = getKey(i);
      acc[key] = getValue(i, cur);
      return omit(acc, _omit);
    }, {}) as ActivityFareBookParamsVM;
  });
}

export function generateResultsUrlParams(input: InputTravelExtra): string {
  return input?.Id && input?.codeType ? `${input?.codeType}${RESULT_PARAMS_DIVIDER}${input?.Id}` : '';
}

export function getActivityResultCodeType(query: string): ActivitySearchCodeType {
  const parts = query?.split?.(RESULT_PARAMS_DIVIDER) ?? [];
  return parts?.[0] as ActivitySearchCodeType ?? null;
}

export function getActivityResultId(query: string): string {
  const parts = query?.split?.(RESULT_PARAMS_DIVIDER) ?? [];
  return parts?.[1] ?? null;
}

function getKey(i: number): string {
  switch (i) {
    case 0:
      return 'PaxType';
    case 1:
      return 'FareId';
    case 2:
      return 'Quantity';
    default:
      return 'SelectedDate';
  }
}

function getValue(i: number, value: string): string | number | PaxType {
  switch (i) {
    case 0:
      return value as PaxType;
    case 1:
    case 2:
      return Number(value);
    default:
      return value;
  }
}
